import {
  ClimberCategory,
  Role,
  RouteCategory,
  View,
  viewAuthorizedRoles,
} from './constants';

export function isViewPermitted(view: View, role: Role) {
  return viewAuthorizedRoles[view].includes(role);
}

type LeadOrBoulderScore<T extends RouteCategory> = T extends 'boulder'
  ? BoulderRouteScore
  : LeadRouteScore;

export const getEmptyScore = <T extends RouteCategory>(
  routeCategory: T,
  climberId: string,
  route: number
): LeadOrBoulderScore<T> => {
  if (routeCategory === 'boulder') {
    return {
      climberId,
      route,
      topped: false,
      zoned: false,
      topAttempts: 0,
      zoneAttempts: 0,
    } as LeadOrBoulderScore<T>;
  }

  return {
    climberId,
    route,
    holdCount: 0,
    plus: false,
    minus: false,
    time: 0,
  } as LeadOrBoulderScore<T>;
};

export function getEmptyRoutesConfig(): RouteNumbersConfig {
  const emptyRoutesForCategories = Object.values(ClimberCategory).reduce(
    (acc, category) => {
      acc[category] = [];
      return acc;
    },
    {} as Record<ClimberCategory, number[]>
  );

  return {
    routeCount: {
      lead: 0,
      boulder: 0,
    },
    perCategory: {
      lead: { ...emptyRoutesForCategories },
      boulder: { ...emptyRoutesForCategories },
    },
  };
}

export function capitalize(string = "") {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function numberRange(start: number, end: number): number[] {
  return Array(end - start).fill(1).map((_, idx) => start + idx);
}
